export default {
	props: {
		/**
		 * Options to pass to the component constructor
		 */
		options: {
			type: Object,
			default: () => ({}),
		},
	},
}
